import { all } from "redux-saga/effects";
import { baoCaoSaga } from "./baoCaoSaga";

export default function* baoCaoSagaWrapper() {
  yield all([baoCaoSaga()]);
}
